const invoiceResult = {
  path: 'invoiceResult',
  component: resolve => require(['../../../../components/pages/signUp/invoiceResult'], resolve)
}
export default invoiceResult



// WEBPACK FOOTER //
// ./src/router/pages/signUp/invoiceResult/index.js